import $ from 'jquery';
import moment from 'moment';
import React from 'react';
import { DayPickerSingleDateController } from 'react-dates';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import { createRoot } from 'react-dom/client';

class SingleDatePicker {
  constructor(formId, options = {}) {
    this.formId = formId;
    this.opts = options;
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleFocusChange = this.handleFocusChange.bind(this);
    this.renderDatepicker = this.renderDatepicker.bind(this);
    this.toggle = this.toggle.bind(this);
  }

  init() {
    if ($(this.opts.dateInput).length === 0) return;
    this.isMobile = window.innerWidth < 992 || window.isMobileTemplate;
    moment.locale('ru');
    this.form = $('#' + this.formId);
    this.body = $('body')[0];
    this.$dateInput = $(this.opts.dateInput);
    this.$hiddenDate = $(this.opts.hiddenDate);

    const initial = this.$hiddenDate.val();
    this.date = initial ? moment(initial, 'DD-MM-YYYY') : null;
    this.focused = false;
    this.isOpen = false;

    this.modal = document.createElement('div');
    this.modal.classList.add('datepicker__modal', 'single_datepicker__modal');
    this.wrapper = document.createElement('div');
    this.wrapper.classList.add('datepicker__wrapper');
    this.modal.appendChild(this.wrapper);
    this.form.append(this.modal);
    if (this.isMobile) {
      let elementHeader = document.createElement('div');
      elementHeader.classList.add('datepicker__header');
      this.closeBtn = document.createElement('a');
      this.closeBtn.classList.add('datepicker__close');
      let label = document.createElement('p');
      label.classList.add('datepicker__header-label');
      label.innerHTML = 'Когда вы планируете отдых?';
      elementHeader.appendChild(this.closeBtn);
      elementHeader.appendChild(label);
      this.modal.prepend(elementHeader);

      let elementFooter = document.createElement('div');
      elementFooter.classList.add('datepicker__footer');
      this.submitBtn = document.createElement('a');
      this.submitBtn.classList.add('datepicker__submit');
      this.submitBtn.innerHTML = this.buttonLabel;
      elementFooter.append(this.submitBtn);
      this.nightsLabel = document.createElement('span');
      this.nightsLabel.classList.add('datepicker__nights');
      elementFooter.append(this.nightsLabel);
      this.modal.append(elementFooter);
    }

    this.modalRoot = createRoot(this.wrapper);
    this.renderDatepicker();

    this.$dateInput.on('click', (e) => {
      this.toggle();
      e.stopPropagation();
    });

    $('body').on('click', (e) => {
      if (this.isOpen && !e.dontHide) this.toggle();
    });

    this.modal.addEventListener(
      'click',
      (e) => {
        e.dontHide = true;
      },
      false
    );
  }

  toggle() {
    this.isOpen = !this.isOpen;
    this.modal.style.visibility = this.isOpen ? 'visible' : 'hidden';
    this.modal.style.opacity = '1';
    if (this.isMobile) {
      this.modal.style.display = this.isOpen ? 'block' : 'none';
      this.body.style.overflow = this.isOpen ? 'hidden' : 'auto';
    }
    this.focused = this.isOpen;
    this.renderDatepicker();
  }

  handleFocusChange({ focused }) {
    this.focused = focused;
    this.renderDatepicker();
  }

  handleDateChange(date) {
    this.date = date;
    this.$dateInput.val(date ? date.format('DD MMM YYYY') : '');
    this.$dateInput.closest('.mtui-text-field__wrapper').addClass('mtui-text-field_filled');
    this.$hiddenDate.val(date ? date.format('DD-MM-YYYY') : '');
    this.$hiddenDate.trigger('change');
    this.toggle();
  }

  reset() {
    this.date = null;
    this.$dateInput.val('');
    this.$hiddenDate.val('');
    this.renderDatepicker();
  }

  renderDayContents(date, dayTypes) {
    return React.createElement('div', { className: 'DayContent' }, date.date());
  }

  renderDatepicker() {
    let dayWidth = 49;
    if ($(window).width() < 360) {
      dayWidth = 42;
    } else if ($(window).width() >= 440) {
      dayWidth = 61;
    }

    this.modalRoot?.render(
      React.createElement(DayPickerSingleDateController, {
        orientation: this.isMobile ? 'verticalScrollable' : 'horizontal',
        date: this.date,
        minDate: moment(),
        maxDate: moment().add(1, 'years'),
        isOutsideRange: (d) => d.isBefore(moment().startOf('day')) || d.isAfter(moment().add(1, 'years')),
        onDateChange: this.handleDateChange,
        focused: this.focused,
        onFocusChange: this.handleFocusChange,
        numberOfMonths: this.isMobile ? 3 : 1,
        firstDayOfWeek: 1,
        isOutsideRange: (d) => d.isBefore(moment().startOf('day')) || d.isAfter(moment().add(1, 'years')),
        daySize: this.isMobile ? dayWidth : (this.opts.dayWidth ?? 45),
        renderDayContents: this.renderDayContents,
        hideKeyboardShortcutsPanel: true,
        phrases: {},
      })
    );
  }
}

export default SingleDatePicker;
